import {
  Box, Button, Table, TableBody, TableCell, TableHead, TableRow,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { RequestsData } from '../../../../redux/Dashboard/rootState';
import { useAppSelector } from '../../../../store/hooks';
import {
  GetHoveredImage,
} from '../../../../utils/helper';
import RequestActionPopup from '../RequestActionPopup';
import AssigneePopupSection from '../../../common/AssigneePopupSection';
import { RequestsStatus } from '../../../../utils/enums';
import { constant } from '../../../../utils/constant';
import DummyImage from '../../../../assets/images/Dummy.png';
import EditIcon from '../../../../assets/images/EditIcon.png';
import './styles.scss';

interface ScheduledProps {
  handleDialogEvent: (val: RequestsData) => void;
  selectedTab: Number
}

function ScheduledSession({ handleDialogEvent, selectedTab }: ScheduledProps) {
  const [requests, setRequests] = useState<RequestsData[]>([]);
  const [hoveredRowId, setHoveredRowId] = useState<number | null>(null);
  const [hoveredTlRowId, setHoveredTlRowId] = useState<number | null>(null);
  const [popupStates, setPopupStates] = useState<boolean[]>([]);
  const [popupPosition, setPopupPosition] = useState({ top: 0, right: 0 });
  const [assigneePopupPosition, setAssigneePopupPosition] = useState({ top: 0, right: 0 });
  const newRef = useRef<HTMLElement>(null);
  const [isAssigneePopup, setAssigneeValue] = useState(false);
  const className = 'scheduledAssigneeSection';
  const requestData = useAppSelector((state) => state.dashboardSlice.requestData);
  const requestActionPopup: boolean = false;

  const onClose = (index: number) => {
    const newPopupStates = [...popupStates];
    newPopupStates[index] = false;
    setPopupStates(newPopupStates);
  };

  const handleOutsideClick = (e: any) => {
    if (newRef.current && !newRef.current.contains(e.target)) {
      onClose(Number(newRef?.current?.id));
    }
  };

  useEffect(() => {
    setRequests(requestData.filter((item: RequestsData) => item.status === RequestsStatus.SCHEDULED));
    setPopupStates(Array(requestData.length).fill(false));
    document.addEventListener('click', handleOutsideClick)
    return () => {
      document.addEventListener('click', handleOutsideClick)
    }
  }, [requestData]);

  const handleMouseEnter = (rowId: number) => {
    setHoveredRowId(rowId);
  }

  const handleMouseLeave = () => {
    setHoveredRowId(null);
  }

  const handleTeledriverMouseEnter = (rowId: number) => {
    setHoveredTlRowId(rowId);
  }

  const handleTeledriverMouseLeave = () => {
    setHoveredTlRowId(null);
  }

  const handleActionBtnClick = (index: number, event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    const rect = event.currentTarget.getBoundingClientRect();
    setPopupPosition({ top: rect.top, right: rect.left });
    const newPopupStates = [...popupStates];
    newPopupStates[index] = !newPopupStates[index];
    setPopupStates(newPopupStates);
  };

  const openSessionInfoPanel = (request: any) => {
    handleDialogEvent(request);
    const val: HTMLElement | null = document.getElementById(`request_${request.id}`);
    if (val) {
      val.classList.add('selected');
    }
  }

  const openAssigneePopup = (index: number, event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    const rect = event.currentTarget.getBoundingClientRect();
    setAssigneePopupPosition({ top: rect.top, right: rect.right })
    setAssigneeValue(true)
  }

  const onCloseAssigneePopup = (val: boolean) => {
    setAssigneeValue(false)
  }

  return (
    <Box className="scheduledSection">
      <Table className="table">
        <TableHead className="table-head">
          <TableRow className="table-row">
            <TableCell className="header-cell teledriver-header">{constant.CUSTOMERNAME}</TableCell>
            <TableCell className="header-cell duration">{constant.TASK}</TableCell>
            <TableCell className="header-cell plateNumber">{constant.PLATENUMBER}</TableCell>
            <TableCell className="header-cell service-id">{constant.TIME}</TableCell>
            <TableCell className="header-cell service-id">{constant.ASSIGNTO}</TableCell>
            <TableCell className="button-column header-cell" />
          </TableRow>
        </TableHead>
        <TableBody className="table-body">
          {
            (requests && requests.length > 0)
              ? requests?.map((request: RequestsData, index: number) => (
                <>
                  <TableRow className={`${request.connectivityStatus} table-row`} key={request.id} id={`request_${request.id}`} onClick={() => openSessionInfoPanel(request)} style={{ cursor: 'pointer' }}>
                    <TableCell className="body-cell teledriverName">
                      {request.customerName}
                    </TableCell>
                    <TableCell className="body-cell taskName">
                      {request.taskType}
                    </TableCell>
                    <TableCell className="body-cell">
                      {request.plateNumber}
                    </TableCell>
                    <TableCell className="body-cell">
                      {request.duration}
                    </TableCell>
                    <TableCell className="body-cell teledriverButton">
                      <Button
                        type="button"
                        className={request.id === hoveredTlRowId ? 'hovered' : ''}
                        onMouseEnter={() => handleTeledriverMouseEnter(request.id)}
                        onMouseLeave={handleTeledriverMouseLeave}
                        onClick={(event) => { openAssigneePopup(index, event) }}
                      >
                        <Box className="leftSection">
                          <img src={request.teledriverProfileImage ? request.teledriverProfileImage : DummyImage} alt="DummyImage" />
                          {request.teleDriver}
                        </Box>
                        {request.id === hoveredTlRowId && (
                          <Box className="rightSection">
                            <img src={EditIcon} alt="DummyImage" />
                          </Box>
                        )}
                      </Button>
                    </TableCell>
                    <TableCell className="body-cell actionCell">
                      <Button
                        className="actionButton"
                        onMouseEnter={() => handleMouseEnter(request.id)}
                        onMouseLeave={handleMouseLeave}
                        onClick={(event) => handleActionBtnClick(index, event)}
                      >
                        <img src={GetHoveredImage(request.id, hoveredRowId!)} alt="Action" />
                      </Button>
                      {popupStates[index] && (
                        <Box ref={newRef} id={index.toString()}>
                          <RequestActionPopup requestActionPopup={requestActionPopup} isOpen={popupStates[index]} onClose={() => onClose(index)} position={popupPosition} />
                        </Box>
                      )}
                    </TableCell>
                  </TableRow>
                  {(requests && requests.length - 1 !== index)
                    ? <Box className="row-gap" />
                    : null}
                </>
              ))
              : (
                <Box className="noData">
                  {constant.NOSCHEDULED}
                </Box>
              )
          }
        </TableBody>
      </Table>
      {
        isAssigneePopup ? (
          <AssigneePopupSection selectedTab={className} parentFunctionCalling={onCloseAssigneePopup} assingeePosition={assigneePopupPosition} />
        )
          : ('')
      }
    </Box>
  )
}
export default ScheduledSession;
